import React from 'react';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';

const onFinePrintLinkClick = (href) => {
  // right now this is how can identify tos vs pp
  const eventName =
    href.indexOf('terms-of-use') > -1 ? TRACKING_ENUMS.EVENT_TERMS_OF_SERVICE : TRACKING_ENUMS.EVENT_PRIVACY_POLICY;

  trackEvent(eventName, null, { profile_start_source: 'other' });
};

export function finePrintRenderer({ linkClassName = '', className = '' }) {
  return {
    link: ({ href, children }) => {
      return (
        <a
          href={href}
          onClick={() => {
            onFinePrintLinkClick(href);
          }}
          className={`finePrintLink ${linkClassName}`}
          target="noopener noreferrer"
        >
          {children}
        </a>
      );
    },
    paragraph: ({ children }) => <p className={`finePrint ${className}`}>{children}</p>,
  };
}
